<template>
  <BaseView :categories="categories" :spus="spus" :current-category="currentCategory" :current-spu="currentSpu"
    :plan="$t('pricing.static_ips.title')">

    <template v-slot:skus>
      <BuyIspProxyView @buy-now="buyNow" :code="searchInfo.code"></BuyIspProxyView>
    </template>
    <template v-slot:dialog>
      <PaymentView v-if="showPaymentView" @close="handleClosePaymentView" ref="paymentView"></PaymentView>
    </template>
  </BaseView>
</template>

<script>
import BuyIspProxyView from "@/components/buy-isp-proxy-view.vue"
import BaseView from "./base.vue"
import PaymentView from "../payment/payment-view.vue"

export default {
  name: 'residential',
  components: {
    BaseView,
    PaymentView,
    BuyIspProxyView,
  },

  data() {
    return {
      Loading: false,
      changeResidentalDayType: true,
      activeCategoryName: 'static',
      showPaymentView: false,

      categories: [
        { name: 'static', url: '/staticisp/' },
        { name: 'rotating', url: '/residential/' },
      ],

      spus: [
        { name: 'Static ISP Proxies', url: '/staticisp/', },
        { name: 'Dedicated DC Proxies', url: '/datacenter_proxies/', }
      ],

      searchInfo: {
        code: ""
      },
    }
  },
  computed: {
  
    currentCategory() {
      return this.categories.find(category => category.name === this.activeCategoryName) || { name: '', url: '' };
    },
    currentSpu() {
      return this.$t("pricing.static_ips.spu");
    },
    
    isLogin() {
      return this.$store.state.isLogin
    },
  },
  watch: {
  },
  created() {
    let params = this.$route.params;
    this.searchInfo.code = params?.regionCode?.toUpperCase() || '';
  },

  methods: {
    
    buyNow: function (item) {
      let that = this;
      if (this.isLogin) {
        item.source = '/staticisp';
        // this.$router.push({ path: '/payment', query: item }).catch(() => {});
        that.showPaymentView = true;
        that.$nextTick(() => {
          if (that.$refs.paymentView) {
            that.$refs.paymentView.updateInfo(item)
          }
        })
      } else {
        that.$router.push({path:'/login', query: {redirect: this.$route.fullPath}})
      }
    },

    handleClosePaymentView() {
      this.showPaymentView = false;
    },

  },

}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-collapse {
    width: 100%;
    border-top: none;
    border-bottom: none;
  }

  .el-collapse-item__header {
    width: 100%;
    border-bottom: none;
  }

  .el-collapse-item__wrap {
    border-bottom: none;
  }

  .el-collapse-item.is-active .el-collapse-item__header .el-icon-caret-right {
    display: none;
  }
  .el-collapse-item.is-active .el-collapse-item__header .el-icon-caret-bottom {
    display: inline-block;
  }

  .el-collapse-item__arrow {
    display: none;
  }
}

</style>